import React from 'react';

import { TextField } from '@occc-app/design-system';

import { isRequired } from '../utils';

interface ILocationDetailsFormContent {
  locationCreate?: boolean;
}

const LocationDetailsFormContent: React.FC<ILocationDetailsFormContent> = ({ locationCreate }) => {
  return (
    <TextField
      name='siteSystemConfiguration.identifier'
      label='Site Configuration ID'
      required
      InputProps={{
        readOnly: !locationCreate,
      }}
      fieldProps={{
        validate: isRequired,
      }}
    />
  );
};

export default LocationDetailsFormContent;
